export interface AgentProfile {
  background: string;
  personality: string;
  communicationStyle: string;
  motto: string;
}

/**
 * Parse the ## Agent Profile section from an agent's markdown content.
 * Returns null if the section is not found or has no parseable fields.
 */
export function parseAgentProfile(markdown: string): AgentProfile | null {
  // Find the ## Agent Profile section
  const profileMatch = markdown.match(/## Agent Profile\s*\n([\s\S]*?)(?=\n## |\n# |$)/);
  if (!profileMatch) return null;

  const section = profileMatch[1];

  const extract = (label: string): string => {
    const re = new RegExp(`\\*\\*${label}:\\*\\*\\s*(.+)`, 'i');
    const m = section.match(re);
    return m ? m[1].trim() : '';
  };

  const background = extract('Background');
  const personality = extract('Personality');
  const communicationStyle = extract('Communication Style');
  const motto = extract('Motto').replace(/^[""\u201C]+|[""\u201D]+$/g, '');

  if (!background && !personality && !communicationStyle && !motto) return null;

  return { background, personality, communicationStyle, motto };
}

/**
 * Strip the ## Agent Profile section and the H1 title from markdown
 * to avoid duplication when rendering in the Agent Definition panel.
 */
export function stripProfileFromMarkdown(markdown: string): string {
  // Remove the ## Agent Profile section
  let result = markdown.replace(/## Agent Profile\s*\n[\s\S]*?(?=\n## |\n# |$)/, '');
  // Remove the H1 title line (first line starting with # )
  result = result.replace(/^# .+\n*/, '');
  // Clean up leading whitespace
  return result.trimStart();
}
